import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "./SiteHeader";

const COLS = [
  { title: "Shop", links: [["/products", "All Deals"], ["/brands", "Partner Brands"], ["/reels", "Reels"], ["/finance", "Finance"]] },
  { title: "Earn", links: [["/register", "Join Free"], ["/referrals", "Refer & Earn"], ["/wallet", "Wallet"], ["/seller/register", "Become a Seller"]] },
];

export const SiteFooter = () => (
  <footer className="bg-primary-900 text-primary-200 mt-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
      <div className="sm:col-span-2 lg:col-span-1">
        <span className="inline-block bg-white rounded-2xl px-3 py-1.5 -rotate-2"><img src={LOGO_URL} alt="M Ventures" className="h-8" /></span>
        <p className="mt-4 text-sm leading-relaxed">Buy. Earn. Refer & Repeat. Cashback on every purchase and rewards for every friend you bring.</p>
      </div>
      {COLS.map((c) => (
        <div key={c.title}>
          <h4 className="font-heading text-white font-bold mb-4">{c.title}</h4>
          <ul className="space-y-2 text-sm">
            {c.links.map(([to, label]) => (
              <li key={to}><Link to={to} className="hover:text-secondary-400 transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
      <div>
        <h4 className="font-heading text-white font-bold mb-4">Contact</h4>
        <ul className="space-y-2 text-sm">
          <li>support@mventures.com</li>
          <li>+91 98765 43210</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-primary-300">© {new Date().getFullYear()} M Ventures. All rights reserved.</div>
  </footer>
);
